import React, { useState } from "react";
import { Layout, Dropdown, Menu } from "antd";
import logo from "../../assets/logo.png";
import { Link, useNavigate } from "react-router-dom";
import InstantCallModal from "./InstantCallModal";

const { Header } = Layout;

const CommonHeader = ({
  bgColor = "transparent",
  circularMenu = false,
  logoColor = "default",
}) => {
  const [menuVisible, setMenuVisible] = useState(false);
  // 2. State to control InstantCallModal visibility
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();

  // 3. Rename the function and update logic
  const handleInstantCallClick = (e) => {
    e.preventDefault();
    setMenuVisible(false);
    setIsModalVisible(true); 
  };

  const handleModalClose = () => {
    setIsModalVisible(false); 
  };

  const getLogoFilter = () => {
    switch (logoColor) {
      case "white":
        return "brightness(0) invert(1)";
      case "black":
        return "brightness(0)";
      case "custom":
        return "none"; // No filter for custom colors
      default:
        return "none"; // Default logo color
    }
  };

  const menuItems = (
    <Menu
      theme="dark"
      style={{
        background: "rgba(0, 0, 0, 0.95)",
        color: "#fff",
        padding: "10px 25px",
        borderRadius: "6px",
        minWidth: "250px",
      }}
      items={[
        {
          key: "0",
          label: (
            <Link to="/" style={{ color: "white" }}>
              Home
            </Link>
          ),
        },
        {
          key: "1",
          label: (
            <Link to="/about-us" style={{ color: "white" }}>
              Who We Are
            </Link>
          ),
        },
        {
          key: "2",
          label: (
            <Link to="/listed-property" style={{ color: "white" }}>
              Our Offerings
            </Link>
          ),
        },
        {
          key: "3",
          label: (
            <Link to="/work" style={{ color: "white" }}>
              How NITM Works
            </Link>
          ),
        },
        {
          key: "4",
          label: (
            <Link to="/policy" style={{ color: "white" }}>
              List Your Property
            </Link>
          ),
        },
        {
          key: "5",
          label: (
            <Link to="/news-room" style={{ color: "white" }}>
              News Room
            </Link>
          ),
        },
        {
          key: "6",
          label: (
            <Link to="/contact-us" style={{ color: "white" }}>
              Contact Us
            </Link>
          ),
        },
        {
          key: "7",
          label: (
            <Link to="/our-story" style={{ color: "white" }}>
              Our Story
            </Link>
          ),
        },

        // Instant Call Button - Link changed to use the new handler
        {
          key: "instant-call",
          label: (
            <div
              onClick={handleInstantCallClick} // Use the new click handler
              style={{
                color: "#EDC71C", // Blinking red text (changed to yellow for contrast without external CSS)
                padding: "12px 16px",
                marginTop: "10px",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "14px",
                cursor: "pointer",
                background: "transparent",
                border: "none",
                // Removed animation property as it requires external CSS setup
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              Instant Call
            </div>
          ),
        },
      ]}
    />
  );

  return (
    <>
      <Header
        style={{
          backgroundColor: bgColor,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingLeft: 30,
          paddingRight: 0,
          height: 64,
          position: "relative",
        }}
      >
        <Link to="/" style={{ display: "inline-block" }}>
          <img
            src={logo}
            alt="logo"
            style={{
              height: "40px",
              objectFit: "contain",
              cursor: "pointer",
              filter: getLogoFilter(),
              transition: "filter 0.3s ease",
            }}
          />
        </Link>

        <div style={{ position: "absolute", right: 0, top: 0, height: "100%" }}>
          <Dropdown
            overlay={menuItems}
            trigger={["click"]}
            open={menuVisible}
            onOpenChange={setMenuVisible}
            placement="bottomRight"
          >
            <div
              style={{
                height: circularMenu ? "50px" : "100%",
                width: circularMenu ? "50px" : "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#D9D9D9E5",
                padding: circularMenu ? "0" : "0 20px",
                cursor: "pointer",
                borderRadius: circularMenu ? "50%" : "0px",
                position: "relative",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                  alignItems: "flex-end",
                }}
              >
                <span
                  style={{
                    width: "24px",
                    height: "3px",
                    background: "black",
                    borderRadius: "2px",
                  }}
                ></span>
                <span
                  style={{
                    width: "18px",
                    height: "3px",
                    background: "black",
                    borderRadius: "2px",
                  }}
                ></span>
                <span
                  style={{
                    width: "12px",
                    height: "3px",
                    background: "black",
                    borderRadius: "2px",
                  }}
                ></span>
              </div>
            </div>
          </Dropdown>
        </div>
      </Header>

      {/* 4. Render the Modal component */}
      <InstantCallModal
        visible={isModalVisible}
        onClose={handleModalClose}
      />
    </>
  );
};

export default CommonHeader;
